let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ecf8G")).then(() => parcelRequire('2LWij'));